import { NitroModules } from "react-native-nitro-modules";
import { rethrowNativeError } from "../nativeError";
var hybrid;
function native() {
  hybrid !== null && hybrid !== void 0 ? hybrid : hybrid = NitroModules.createHybridObject("OneAppIcon");
  return hybrid;
}
function isSupported() {
  return native().isSupported().catch(rethrowNativeError);
}
function getCurrentName() {
  return native().getCurrentName().catch(rethrowNativeError);
}
function setIcon(name) {
  return native().setIcon(name).catch(rethrowNativeError);
}
var AppIcon = Object.freeze({
  isSupported,
  getCurrentName,
  setIcon
});
export {
  AppIcon
};
//# sourceMappingURL=index.native.js.map
